const variantStyles = {
  usbCount: 'font-bold leading-[130%] tracking-[-3%] text-[#FFFFFF]',
  hero: 'font-regular leading-[63.2px] tracking-[-4%]',
  newhero: 'font-regular leading-[63.2px] tracking-[-4%]',
  heading: 'font-medium leading-[56.2px] tracking-[-4%]',
  body: 'font-regular leading-[21.1px] tracking-[-0.03em] text-[#FFFFFFE5]',
  muted: 'leading-7 text-white/50',
  caption: 'uppercase tracking-wide text-white/40',
  h3: 'font-regular leading-auto tracking-[-0.04em]',
  h26: 'font-medium leading-[150%] tracking-[-0.03em]',
  fontWbold: 'font-bold leading-[150%] tracking-[-0.03em]',
  text: 'font-regular leading-[150%] tracking-[-0.03em]',
  medium: 'font-medium leading-[100%] tracking-[0%]',
  regular: 'font-regular leading-[100%] tracking-[0%]',
  bold: 'font-bold leading-[100%] tracking-[-0.03em]'
};

const sizeStyles = {
  xs: 'text-[12.3px]',      // 12
  ms: 'text-[13.17px]',
  sm: 'text-[14.05px]',      // 14
  h15: 'text-[15.81px]',
  base: 'text-[17.56px]',  // 16
  h16: 'text-[16px]',
  h20: 'text-[20px]',
  h21: 'text-[21.08px]',
  h24: 'text-[24.59px]',
  h26: 'text-[26.35px]',
  h3: 'text-[28.1px]',
  h29: 'text-[29.4px]',
  md: 'text-[49.18px]',
  lg: 'md:text-[56.21px] text-[46px]',      // 18
  xl: 'text-[73.77px]',
  exl: 'text-[131.74px]',
  '2xl': 'text-2xl',
  '4xl': 'text-4xl',
  '5xl': 'text-5xl',
  '6xl': 'text-6xl',
};

export default function Typography({
  as: Tag = 'div',
  variant = 'body',
  size = 'base',
  className = '',
  children,
  ...props
}) {
  return (
    <Tag
      className={`${variantStyles[variant]} ${sizeStyles[size]} ${className}`}
      {...props}
    >
      {children}
    </Tag>
  );
}